module.exports = __webpack_public_path__ + "img/facebook-shape@mb.982bc9f.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/facebook-shape@mb.svg
// module id = Eo7i
// module chunks = 13